/* eslint-disable default-param-last */
const homeReducer = (state = {}, action) => {
  switch (action.type) {
    case 'SUBSCRIBE_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'SUBSCRIBE_SUCCESS':
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default homeReducer;
